import classNames from "classnames";
import { useRouter } from "next/router";
import { useState } from "react";
import * as React from "react";
import { MAX_FAVORITES } from "@components/FavoriteTeamModal";
import Auth from "@hooks/useAuth";
import { paths } from "@libs/paths";
import { GTMEvent, GTMEvents } from "@libs/utils/gtm";
import {
  useFavoriteTeamButton_CreateUserFavoriteTeamMutation as useCreateUserFavoriteTeamMutation,
  useFavoriteTeamButton_DeleteUserFavoriteTeamMutation as useDeleteUserFavoriteTeamMutation,
} from "./__generated__/mutations";
import styles from "./index.module.css";

type Props = {
  teamId: number;
};

const FavoriteTeamButton: React.FC<Props> = ({ teamId }) => {
  const { push } = useRouter();

  const {
    fanstaUser,
    loadFanstaUser,
    isCurrentUserLoggedOut,
    isFanstaUserReady,
  } = Auth.useContainer();
  const favoriteTeamIds =
    fanstaUser?.currentUser.user?.favoriteTeams.map((t) => t.id) || [];
  const isAdded = favoriteTeamIds.includes(teamId);
  const isLimit = favoriteTeamIds.length >= MAX_FAVORITES;

  const [isBusy, setIsBusy] = useState(false);
  const [createUserFavoriteTeam] = useCreateUserFavoriteTeamMutation({
    variables: {
      teamId: teamId,
    },
  });
  const [deleteUserFavoriteTeam] = useDeleteUserFavoriteTeamMutation({
    variables: {
      teamId: teamId,
    },
  });
  const handleClick = async () => {
    if (isBusy) {
      return;
    }
    setIsBusy(true);

    if (isCurrentUserLoggedOut) {
      await push(paths.login);
      return;
    }

    if (isAdded) {
      await deleteUserFavoriteTeam();
      GTMEvent(GTMEvents.removeFavoriteTeamButtonPressed(teamId));
    } else {
      await createUserFavoriteTeam();
      GTMEvent(GTMEvents.addFavoriteTeamButtonPressed(teamId));
    }
    await loadFanstaUser();

    setIsBusy(false);
  };
  return (
    <button
      disabled={!isFanstaUserReady || (!isAdded && isLimit)}
      className={classNames(styles.addFavoriteTeam, {
        [styles.isAdded]: isAdded,
      })}
      onClick={handleClick}
    >
      {isAdded ? (
        <span className={styles.addFavoriteTeamLabel}>お気に入り中</span>
      ) : (
        <span className={styles.addFavoriteTeamLabel}>お気に入りに追加</span>
      )}
    </button>
  );
};
export default FavoriteTeamButton;
